"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
// next-themes@0.4+ exports its types from the root entry; the
// older `next-themes/dist/types` path was removed.
import { type ThemeProviderProps } from "next-themes";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const scriptProps =
    typeof window === "undefined"
      ? undefined
      : ({ type: "application/json" } as const);

  return (
    <NextThemesProvider scriptProps={scriptProps} {...props}>
      {children}
    </NextThemesProvider>
  );
}
